import { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Button,
} from "@mui/material";
import { getAdminPeople } from "../client/admin";

function PeopleManagePage() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, search]);

  async function loadData() {
    const res = await getAdminPeople({
      page: page + 1,
      page_size: pageSize,
      search,
    });
    if (res) {
      setRows(res.list || []);
      setTotal(res.total || 0);
    }
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        排盘记录
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <TextField
          label="搜索姓名/出生地/用户"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && loadData()}
        />
        <Button variant="contained" onClick={loadData}>
          搜索
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>姓名</TableCell>
              <TableCell>性别</TableCell>
              <TableCell>出生时间</TableCell>
              <TableCell>出生地</TableCell>
              <TableCell>所属用户</TableCell>
              <TableCell>计算时间</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.gender}</TableCell>
                <TableCell>{row.birthday_str}</TableCell>
                <TableCell>{row.birthplace || "-"}</TableCell>
                <TableCell>{row.user_username || row.anonymous_id || "-"}</TableCell>
                <TableCell>
                  {row.computed_at ? new Date(row.computed_at).toLocaleString() : "-"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        rowsPerPage={pageSize}
        onRowsPerPageChange={(e) => {
          setPageSize(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 20, 50]}
      />
    </Box>
  );
}

export default PeopleManagePage;
